module.exports = __webpack_public_path__ + "img/add.0463f956.svg";